import { Component, OnInit } from '@angular/core';
import { AppSingle } from '../../app-single';
import { ProductModel } from '../../models/product.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../services/product.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { ConfigurationService } from '../../services/configuration.service';
import { ConfigurationModel } from '../../models/configuration.model';
import { RestrictionModel } from '../../models/restriction.mode';
import { CategoryModel } from '../../models/category.model';

@Component({
  selector: 'app-restriction-single',
  templateUrl: './restriction-single.component.html',
  styleUrls: ['./restriction-single.component.less']
})
export class RestrictionSingleComponent extends AppSingle implements OnInit {

  products: ProductModel[] = new Array<ProductModel>();

  constructor(route: ActivatedRoute, private router: Router, private productService: ProductService,
    private notificationService: NotificationService, private configurationService: ConfigurationService) {
    super(route);
  }

  ngOnInit() {
    this.productService.setIsCancelable();
    if (this.tipo === 'nominal') {
      this.productService.getAll(this.companyId)
      .then((_products: ProductModel[]) => {
        this.products = _products;
        return this.configurationService.getRestriction(this.id);
      })
      .then((_configuration: ConfigurationModel) => {
        this.formatCheckedProducts(_configuration);
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
    } else {
      this.productService.getAll(this.companyId)
      .then((_products: ProductModel[]) => {
        this.products = _products;
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
    }
  }

  private formatCheckedProducts(configurations: ConfigurationModel) {
    configurations.restrictions.forEach(restrication => {
      this.products.forEach((product) => {
        if (restrication.Id === product.id) {
          product.isRestricted = true;
          product.tempIsRestricted = true;
        } else {
          product.tempIsRestricted = false;
        }
      });
    });
  }

  setRestriction(event, product: ProductModel) {
    if (product.tempIsRestricted === product.isRestricted) {
      this.productService.setIsCancelable();
      this.configurationService.updateRestriction(this.id, this.formatProductModel());
    } else {
      this.productService.setIsNotCancelable();
      this.configurationService.updateRestriction(this.id, this.formatProductModel());
    }
    product.isRestricted = event.checked;
  }

  // confirmRestriction() {
  //   this.configurationService.updateRestriction(this.id, this.formatProductModel())
  //     .then(() => {
  //       this.productService.setIsCancelable();
  //       this.notificationService.showSuccessNotification('Restrições salvas com sucesso!');
  //     })
  //     .catch((err) => {
  //       this.notificationService.showErrorNotification(err.message);
  //     });
  // }

  private formatProductModel(): RestrictionModel[] {
    const restrictions = new Array<RestrictionModel>();

    this.products.forEach((product) => {
      if (product.isRestricted) {
        const restriction = new RestrictionModel();
        restriction.category = new CategoryModel();
        restriction.category.id = product.categoryId;
        restriction.category.name = product.categoryName;
        restriction.name = product.name;
        restriction.price = product.price;
        restriction.Id = product.id;
        restrictions.push(restriction);
      }
    });
    return restrictions;
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/restriction-single/restriction-single.component.ts